import React from 'react';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
  },
  title: {
    textAlign: 'center',
  },
  section: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
  },
  paragraph: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit*5,
  }
});

const Detail = ({ classes, title, sections }) => {
  return(
    <CardContent className={classes.root}>
      {title &&
       <Typography
         variant="subheading"
         className={classes.title}>
         {title}
       </Typography>
      }
      {sections &&
        sections.map((section, i) => {
          return(
            <div key={i} className={classes.section}>
              <Typography>
                {section.heading}:
              </Typography>
              {section.paragraphs.map((paragraph, i) => {
                return(
                  <Typography key={i} className={classes.paragraph}>
                    {paragraph}
                  </Typography>
                );
              })}
            </div>
          );
        })
      }
    </CardContent>
  );
};

export default withStyles(styles)(Detail);



// WEBPACK FOOTER //
// ./src/components/Info/Detail.jsx